import React from 'react'

const CallIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><path d="M27.593 19.692a17.033 17.033 0 0 1-5.349-.852 2.445 2.445 0 0 0-2.378.5l-3.373 2.546a18.641 18.641 0 0 1-8.381-8.38l2.471-3.285a2.425 2.425 0 0 0 .6-2.457 17.059 17.059 0 0 1-.855-5.358 2.41 2.41 0 0 0-2.411-2.406h-5.51a2.41 2.41 0 0 0-2.407 2.407 27.624 27.624 0 0 0 27.593 27.593 2.41 2.41 0 0 0 2.407-2.407v-5.493a2.41 2.41 0 0 0-2.407-2.408z"  fill={props.fill}/></svg>
)

export default CallIcon